import { useState, type ReactNode } from 'react'
import Sidebar from './Sidebar'
import TeamMemberBanner from './layout/TeamMemberBanner'
import { Menu } from 'lucide-react'

interface MainLayoutProps {
  children: ReactNode
  rightPanel?: ReactNode
  pageTitle?: string
}

export default function MainLayout({ children, rightPanel }: MainLayoutProps) {
  const [collapsed, setCollapsed] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <div className="min-h-screen bg-navy-deep">
      <Sidebar
        collapsed={collapsed}
        onCollapse={() => setCollapsed((prev) => !prev)}
        mobileOpen={mobileOpen}
        onMobileToggle={() => setMobileOpen((prev) => !prev)}
      />

      {/* Mobile header — visible below lg */}
      <div className="sticky top-0 z-20 flex items-center gap-3 px-4 py-3 bg-navy-deep border-b border-white/[0.06] lg:hidden">
        <button
          onClick={() => setMobileOpen(true)}
          className="text-gray-400 hover:text-gray-100 transition-colors"
        >
          <Menu size={20} />
        </button>
        <span className="text-sm font-bold text-gray-100">GraspPod</span>
      </div>

      {/* Main content area */}
      <main
        className={`transition-all duration-200 ${rightPanel ? 'xl:mr-80' : ''}
          ${collapsed ? 'lg:ml-16' : 'lg:ml-60'}
        `}
      >
        <TeamMemberBanner />
        <div className="px-5 py-5 lg:px-9 lg:py-7 min-h-screen">
          {children}
        </div>
      </main>

      {/* Right panel */}
      {rightPanel && (
        <aside className="fixed top-0 right-0 w-80 h-screen bg-gray-800 border-l border-white/[0.06] px-5 py-7 overflow-y-auto hidden xl:block">
          {rightPanel}
        </aside>
      )}

      {/* Phase 2D: IvyChat mount removed. The IvyDock is portal-mounted at App
          root (see src/App.tsx) so it persists across all route changes and
          doesn't depend on MainLayout's lifecycle. Sidebar wires directly into
          IvyDockContext via useIvyDock(). */}
    </div>
  )
}
